import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
CalendarDays,
MapPin,
Building2,
Users,
ArrowRight,
} from "lucide-react";

import { UserRound, GraduationCap } from "lucide-react";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";


const AboutPage = () => {
const { slug } = useParams();
console.log("Current slug:", slug);
const [active, setActive] = useState(false);
const [teachers, setTeachers] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
const fetchTeachers = async () => {
try {
// const response = await fetch("http://127.0.0.1:8000/api/teachers");
const API_URL =
window.location.hostname === "localhost" ||
window.location.hostname === "127.0.0.1"
? "http://127.0.0.1:8000/api/teachers"
: "https://api.kunainital.ac.in/api/teachers";

const response = await fetch(API_URL);
const result = await response.json();

if (result.success) {
const heads = result.data?.data?.filter(
(teacher) => Number(teacher.designation?.id) == 1
);

setTeachers(heads || []);
}
} catch (error) {
console.error("Error fetching teachers:", error);
} finally {
setLoading(false);
}
};

fetchTeachers();
}, []);

switch (slug) {


case "directors":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Campus Administration
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        Directors
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B] font-gill">
                    DIRECTORS OF KUMAUN UNIVERSITY, NAINITAL
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>
    {/* HIGHLIGHTS */}
    <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-1xl mx-auto mb-12">



            </div>

            <div className="grid md:grid-cols-3 gap-6">

                {/* ================= director1 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715338488_campusadm.jpg" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill">
                        Prof. L.K. Singh
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of Sir J.C. Bose Technical Campus Bhimtal,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i
                                className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4 text-lg font-gill"></i>
                            <p> Management Studies</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4 "></i>
                            <p className="text-lg font-gill">l_k_singh@yahoo.co.in</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">9412427965</p>
                        </div>

                    </div>


                </div>

                {/* ================= director1 end ================= */}

                {/* ================= director3 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715619659_dean.jpg" alt="Prof. Sanjay Pant"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors text-lg font-gill">
                        Prof. Sanjay Pant
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of D.S.B. Campus, Nainital,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill"> Physics Department </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">sanjayphotophys@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">9411198359</p>
                        </div>

                    </div>


                </div>

                {/* ================= director2 end ================= */}

                {/* ================= director2 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715337961_cmpAdm3.jpg" alt="Prof. Divya U. Joshi"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors text-lg font-gill">
                        Prof. Divya U. Joshi
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of Internal Quality Assurance Cell (IQAC),
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">Political Science Department</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">divyauj@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">9411102340</p>
                        </div>

                    </div>


                </div>

                {/* ================= director3 end ================= */}

                {/* ================= director4 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715338021_cmpAdm.jpg" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill">
                        Dr. Nand Gopal Sahoo
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of Research,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill"> Chemistry Department</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">ngsahoo@yahoo.co.in</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> 9149135437</p>
                        </div>

                    </div>


                </div>

                {/* ================= director4 end ================= */}

                {/* ================= director4 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715337961_cmpAdm3.jpg" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill">
                        Prof. Divya U. Joshi
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of Director UGC-HRDC,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill"> Political Science Department</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">divyauj@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9411102340</p>
                        </div>

                    </div>


                </div>

                {/* ================= director4 end ================= */}

                {/* ================= director5 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715337904_cmAdm.png" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors text-lg font-gill">
                        Dr. Ashish Tewari
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of Innovation and Incubation Centre,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">Forestry Department</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">atewari69@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9412994110</p>
                        </div>

                    </div>


                </div>

                {/* ================= director5 end ================= */}

                {/* ================= director6 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715337789_camAdm4.jpg" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors text-lg font-gill">
                        Dr. Shuchi Bisht
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of Development and Planning,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">Physics Department</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">shbisht@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9411196444</p>
                        </div>

                    </div>


                </div>

                {/* ================= director6 end ================= */}

                {/* ================= director7 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/registrar_ku.jpeg" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill">
                        Prof. Rajnish Pande
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-justify text-lg font-gill">
                                Director of Institute of Professional Studies & Development Research(IPSDR),
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">Economics Department</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">rajnishpande@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9412084716</p>
                        </div>

                    </div>


                </div>

                {/* ================= director7 end ================= */}
                {/* ================= director8 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/lalit-tiwari-1727420038_camAdm5.jpg" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors font-gill">
                        Prof. Lalit Tewari
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill">
                                Director of Directorate of Visiting Professor,
                            </p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p className="text-lg font-gill"> Botany Department</p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>atewari69@gmail.com</p>
                        </div> */}
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9412362085</p>
                        </div>

                    </div>


                </div>

                {/* ================= director8 end ================= */}
            </div>
        </div>
    </section>
    {/* ================= ORGANOGRAM SECTION ================= */}

    <Footer />

</div>
);

case "deans":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Campus Administration
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        Deans
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B]  font-gill">
                    DEANS OF KUMAUN UNIVERSITY, NAINITAL
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>
    {/* HIGHLIGHTS */}
    <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-1xl mx-auto mb-12">



            </div>

            <div className="grid md:grid-cols-3 gap-6">
                 {/* ================= director1 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/registrar_ku.jpeg" alt="Dr. Brijmohan Pharswan"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                        Prof. Rajnish Pande
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                Dean Faculty of Arts
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Political Science Department</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>hodeconomics@kunainital.ac.in</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9412084716</p>
                        </div>

                    </div>


                </div>

                {/* ================= director1 end ================= */}

                {/* ================= director2 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/1715619659_dean.jpg" alt="Prof. Sanjay Pant"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                        Prof. Sanjay Pant
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                Dean Faculty of Science
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Geography Department</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>sanjayphotophys@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9411198359</p>
                        </div>

                    </div>


                </div>

                {/* ================= director2 end ================= */}


                 {/* ================= director3 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/amit_dean.png" alt="Prof. Amit Joshi"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                        Prof. Amit Joshi
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                               Dean Faculty of Management
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Chemistry Department</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>amitjoshiaj@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9410349047</p>
                        </div>

                    </div>


                </div>

                {/* ================= director3 end ================= */}
{/* ================= director4 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/Dr Mahendra Rana-1718691903.png" alt="Prof. Mahendra Rana"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110
                                    " />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                        Prof. Mahendra Rana
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                Dean Faculty of Biomedical Science
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Chemistry Department</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>kudeanbiomedical@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9410176405</p>
                        </div>

                    </div>


                </div>

                {/* ================= director4 end ================= */}

                {/* ================= director5 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    
                    {/* Photo */}

                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">


                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/head_1.JPG" alt="Prof. L.S. Lodhiyal"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110" />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                        Prof. L.S. Lodhiyal
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                Dean Faculty of Agriculture
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Management Studies</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>lslodhiyal@yahoo.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9410373658</p>
                        </div>

                    </div>


                </div>

                {/* ================= director5 end ================= */}
  {/* ================= director6 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    
                    {/* Photo */}

                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">


                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/lalit-tiwari-1727420038_camAdm5.jpg" alt="Prof. Lalit Tiwari"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110" />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                        Prof. Lalit Tiwari
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                Dean Faculty of Education
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Management Studies</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>tewari@rediffmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9412362085</p>
                        </div>

                    </div>


                </div>

                {/* ================= director6 end ================= */}
               
                
 
               
{/* ================= director8 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    
                    {/* Photo */}

                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">


                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/reena_dean.png" alt="Prof. Reena Singh"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110" />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                       Prof. Reena Singh
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                               Dean Faculty of Visual Art
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Management Studies</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>reenasingh@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>5942235650</p>
                        </div>

                    </div>


                </div>

                {/* ================= director8 end ================= */}
               
{/* ================= director9 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    
                    {/* Photo */}

                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">


                        <div
                            className="
                                    relative
                                    w-40 h-40
                                    rounded-full
                                    overflow-hidden
                                    bg-[#EAF5EF]
                                    shadow-sm
                                    group-hover:shadow-lg
                                    transition-all duration-300
                                ">
                            <img src="/images/dr_vijay_dean.jpg" alt="Dr. Vijay Kumar"
                                className=" w-full h-full object-cover object-top transition-all duration-300 group-hover:scale-110" />
                        </div>

                    </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                       Dr. Vijay Kumar
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                              Dean Faculty of Commerce
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> Management Studies</p>
                        </div> */}

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>vparchey@gmail.com</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9410117519</p>
                        </div>

                    </div>


                </div>

                {/* ================= director9 end ================= */}

            </div>
        </div>
    </section>
    {/* ================= ORGANOGRAM SECTION ================= */}

    <Footer />

</div>
);

case "heads":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        Campus Administration
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        Heads
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B]">
                    Heads OF KUMAUN UNIVERSITY, NAINITAL
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>
    {/* HIGHLIGHTS */}
    <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-1xl mx-auto mb-12">



            </div>

            {loading ? (
            <div className="col-span-full text-center py-10">
                <p className="text-gray-500">Loading...</p>
            </div>
            ) : teachers.length === 0 ? (
            <div className="col-span-full text-center py-10">
                <p className="text-gray-500">
                    No Heads found.
                </p>
            </div>
            ) : (
            <div className="grid md:grid-cols-3 gap-6">
                {teachers.map((teacher) => (
                <div key={teacher.id}
                    className="group relative bg-white rounded-2xl p-8
                                border border-gray-200 shadow-md
                                hover:shadow-xl transition-all duration-300
                                overflow-hidden">
                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                                    rounded-full bg-[#EAF5EF]
                                    group-hover:bg-[#88bfe1]
                                    transition-all duration-300" />

                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">
                        <div
                            className="
                                        relative
                                        w-40 h-40
                                        rounded-full
                                        overflow-hidden
                                        bg-[#EAF5EF]
                                        shadow-sm
                                        group-hover:shadow-lg
                                        transition-all duration-300
                                        ">
                            {teacher.profile_photo ? (
                            <img src={teacher.profile_photo} alt={teacher.name}
                                className="
                                                w-full h-full object-cover object-top
                                                transition-all duration-300
                                                group-hover:scale-110
                                                " />
                            ) : (
                            <div className="w-full h-full flex items-center justify-center text-gray-400">
                                <i className="fa-solid fa-user text-5xl"></i>
                            </div>
                            )}
                        </div>
                    </div>

                    {/* Name */}
                    <h3
                        className="
                                    text-xl font-bold text-[#123B5D] mb-4
                                    group-hover:text-[#0B5D3B]
                                    transition-colors
                                    ">
                        {teacher.name}
                    </h3>

                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        {/* Designation */}
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>

                            <p>
                                {teacher.designation?.name}
                            </p>
                        </div>


                        {/* Department */}
                        {teacher.department?.name && (
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building text-[#E52323] text-[17px] mt-1 w-4"></i>

                            <p>
                                {teacher.department.name}
                            </p>
                        </div>
                        )}

                        {/* Department campus name */}
                        {teacher.department?.name && (
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-building text-[#E52323] text-[17px] mt-1 w-4"></i>

                            <p>
                                {teacher.department.campus_name}
                            </p>
                        </div>
                        )}


                        {/* Email */}
                        {teacher.email && (
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>

                            <p>
                                {teacher.email}
                            </p>
                        </div>
                        )}

                        {/* Mobile */}
                        {teacher.mobile && (
                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>

                            <p>
                                {teacher.mobile}
                            </p>
                        </div>
                        )}

                    </div>
                </div>
                ))}
            </div>
            )}
        </div>
    </section>
    {/* ================= ORGANOGRAM SECTION ================= */}

    <Footer />

</div>
);










default:
return (
<div className="min-h-screen flex items-center justify-center">
    <h1 className="text-3xl font-bold">
        Page Not Found
    </h1>
</div>
);
}
};


/* STAT COMPONENT */

const Stat = ({ icon, value, label }) => {
return (
<div className="p-6 text-center border-b md:border-b-0 md:border-r last:border-0">
    <div className="flex justify-center text-[var(--terracotta)] mb-3">
        {icon}
    </div>

    <div className="text-2xl font-bold text-[var(--ink)]">
        {value}
    </div>

    <div className="text-sm text-gray-500 mt-1">
        {label}
    </div>
</div>
);
};


/* HIGHLIGHT COMPONENT */

const Highlight = ({ title, text }) => {
return (
<div className="p-7 rounded-2xl border border-[var(--cream-deep)] bg-[var(--paper)] hover:shadow-lg transition">
    <h3 className="text-xl font-bold text-[var(--ink)] mb-3">
        {title}
    </h3>

    <p className="text-gray-600 leading-7">
        {text}
    </p>
</div>
);

};

export default AboutPage;
